import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import baseAdminApi from "./features/baseApi";

import languageSlice from "./features/Setting/Language/languageSlice";
import userSlice from "./features/User/userSlice";
import menuSlice from "./features/Setting/Menu/menuSlice";

export const store = configureStore({
  reducer: {
    [baseAdminApi.reducerPath]: baseAdminApi.reducer,
    language: languageSlice,
    user: userSlice,
    menu: menuSlice,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseAdminApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

setupListeners(store.dispatch);
